import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { messageTypes } from './constants'

const useIframeCopies = () => {
  const { i18n } = useTranslation()
  const [iframeCopies, setIframeCopies] = useState(null)

  const handleMessage = useCallback(
    event => {
      const { type, payload } = event.data || {}

      if (type !== messageTypes.copiesUpdate) return

      setIframeCopies(payload)

      if (payload?.lang && payload.lang !== i18n.language) {
        i18n.changeLanguage(payload.lang)
        localStorage.language = payload.lang
      }
    },
    [i18n]
  )

  useEffect(() => {
    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [handleMessage])

  return { iframeCopies }
}

export default useIframeCopies
